"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAppUserSync = void 0;
exports.cancelPromise = cancelPromise;
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const application_host_1 = require("../common/application-host");
const cache_1 = __importDefault(require("../helper/cache"));
const storage_1 = __importDefault(require("../helper/storage"));
const character_1 = require("../services/character");
const user_1 = require("../slices/user");
const useAppState_1 = require("./useAppState");
const useAuth_1 = require("./useAuth");
const react_native_1 = require("react-native");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function cancelPromise(ref) {
    ref.current?.cancel?.();
}
/**
 *
 * @param props
 * @returns
 */
const useAppUserSync = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const appUser = (0, react_redux_1.useSelector)((state) => state.getUserOptions.appUser);
    const fbUser = (0, react_redux_1.useSelector)((state) => state.getUserOptions.fbUser);
    const { signOutAppState } = (0, useAppState_1.useAppState)();
    const fetchApiRef = (0, react_1.useRef)();
    const { auth } = (0, useAuth_1.useAuth)();
    (0, react_1.useEffect)(() => {
        return cancelPromise(fetchApiRef);
    }, []);
    // clear local storage & session data
    const clearSession = (0, react_1.useCallback)(async () => {
        await cache_1.default.setItem(`appUser_${application_host_1.ENV_TYPE}`, {});
        await dispatch((0, user_1.setAppUser)({}));
    }, []);
    // Check if user exists in local storage, create otherwise. Once available ID,
    // it will be in system untill user log out.
    const checkUser = (0, react_1.useCallback)(async () => {
        // Get env specific user data from storage
        let storageAppUser = await cache_1.default.getItem(`appUser_${application_host_1.ENV_TYPE}`);
        const token = await storage_1.default.getItem("authToken");
        console.log("Check user.....++", appUser?.id, fbUser?.uid, appUser, storageAppUser);
        // If app user is & env are not matching, we need to have new
        if (!token && (!appUser?.id || appUser.env !== application_host_1.ENV_TYPE)) {
            // We have storage correct user , so set in app user
            if (storageAppUser?.id && storageAppUser.env === application_host_1.ENV_TYPE) {
                console.log("Set appUser:", `ENV:${application_host_1.ENV_TYPE}`, storageAppUser);
                // if not set
                if (appUser?.id !== storageAppUser?.id) {
                    dispatch((0, user_1.setAppUser)(storageAppUser));
                }
            }
            else if (react_native_1.Platform.OS != 'web') {
                // We have wrong user in storage, create new tmp user and store
                console.log("Creating new sync user..");
                // cancel any previous user call
                cancelPromise(fetchApiRef);
                const results = (0, character_1.createNewSyncUser)();
                fetchApiRef.current = results;
                results.then(async (resp) => {
                    if (resp?.data) {
                        let tempApiData = resp.data;
                        tempApiData.env = application_host_1.ENV_TYPE;
                        await cache_1.default.setItem(`appUser_${application_host_1.ENV_TYPE}`, tempApiData);
                        console.log("Created new user sucessfully!");
                        console.log("token", token);
                        await dispatch((0, user_1.setAppUser)(tempApiData));
                    }
                });
            }
        }
        else if (token && appUser?.id) {
            console.log("Remove model..");
            await dispatch((0, user_1.setShowUserModal)(false));
        }
        else {
            if (!storageAppUser?.id) {
                await cache_1.default.setItem(`appUser_${application_host_1.ENV_TYPE}`, appUser);
            }
            else {
                const user = await auth().currentUser;
                if (!user) {
                    await signOutAppState();
                }
                else {
                    await user?.getIdToken(true)?.then(async () => {
                        console.log("User.... existing..");
                        // dispatch(setAppUser(storageAppUser));
                    });
                }
            }
        }
    }, [appUser, fetchApiRef, user_1.setAppUser]);
    return { checkUser, clearSession };
};
exports.useAppUserSync = useAppUserSync;
